<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La celebración internacional</h2>
    <img @click="imageClicked(0)" src="galerias/sala3/S3_G2.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Celebración del 5 de mayo en Estados Unidos</b><br>
      Año: 2019<br>
      Técnica: Fotografía digital<br>
      Colección: El Sol de México<br>
    </p>
    <p>A partir de los años 60 del siglo XX, activistas chicanos impulsaron esta efeméride como una fecha para celebrar la herencia y cultura mexicana.</p>
    <p>En la actualidad, el 5 de mayo se celebra principalmente en ciudades con población de ascendencia mexicana como Los Ángeles, Chicago y Houston.</p>
    <p>Algunas de las actividades que se llevan a cabo en estas celebraciones son desfiles, conciertos de música mariachi y festivales culinarios.</p>
    <h5>Ver más:</h5>
    <p><a target="_blank" href="https://www.elfinanciero.com.mx/el-preguntario/2021/05/05/por-que-el-5-de-mayo-es-la-fiesta-mexicana-mas-gringa-ever/">www.elfinanciero.com.mx</a></p>
    <p><a target="_blank" href="https://www.elsoldemexico.com.mx/mexico/sociedad/%C2%BFQu%C3%A9-se-celebra-el-5-de-mayo-y-por-qu%C3%A9-es-tan-significativo-1-121499.html">www.elsoldemexico.com.mx</a></p>
  </div>
</template>

<script>
export default {
  name: "s32g02",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
